class TesterModal extends HTMLElement {
  constructor() {
    super();
    this.handleKeyUp = this.handleKeyUp.bind(this);
  }

  connectedCallback() {
    this.overlay = this.querySelector('.tester-modal-overlay');
    this.trigger = this.querySelector('[data-tester-trigger]');

    if (this.overlay && !this.overlay.isMoved) {
      this.overlay.isMoved = true;
      document.body.appendChild(this.overlay);
    }

    this.trigger?.addEventListener('click', () => this.open());

    this.overlay?.addEventListener('click', this.handleOverlayClick.bind(this));

    document.addEventListener('keyup', this.handleKeyUp);
  }

  disconnectedCallback() {
    document.removeEventListener('keyup', this.handleKeyUp);

    // Clean up the overlay from document.body to prevent duplication
    if (this.overlay && this.overlay.isMoved) {
      this.overlay.classList.remove('is-open');
      if (this.overlay.parentNode === document.body) {
        document.body.removeChild(this.overlay);
      }
      this.overlay.isMoved = false;
    }

    document.body.classList.remove('overflow-hidden');
  }

  handleKeyUp(event) {
    if (event.code?.toUpperCase() === 'ESCAPE') {
      this.close();
    }
  }

  handleOverlayClick(event) {
    if (
      event.target.closest('[data-tester-close]') ||
      event.target.classList.contains('tester-modal-overlay')
    ) {
      this.close();
    }
  }

  open() {
    if (!this.overlay) return;
    this.overlay.classList.add('is-open');
    document.body.classList.add('overflow-hidden');

    // Hide only top-level siblings of the modal's root, not everything
    document.querySelectorAll('body > *').forEach((el) => {
      if (!el.contains(this.overlay)) {
        el._hadAriaHidden = el.hasAttribute('aria-hidden'); // track prior state
        el.setAttribute('aria-hidden', 'true');
      }
    });

    if (window._theme?.focusTrap) {
      window._theme.focusTrap(jQuery('.tester-modal-container'), () => {
        this.overlay.classList.remove('is-open');
        this.trigger?.setAttribute('aria-expanded', 'false');
        this.trigger?.focus();
      });
    }
  }

  close() {
    if (!this.overlay || !this.overlay.classList.contains('is-open')) return;
    this.overlay.classList.remove('is-open');
    document.body.classList.remove('overflow-hidden');
    this.trigger?.focus();

    // Restore only what we hid — don't blindly removeAttr from everything
    document.querySelectorAll('body > *').forEach((el) => {
      if (!el.contains(this.overlay)) {
        if (!el._hadAriaHidden) {
          el.removeAttribute('aria-hidden');
        }
        delete el._hadAriaHidden;
      }
    });
  }
}

if (!customElements.get('tester-modal')) {
  customElements.define('tester-modal', TesterModal);
}
